import React from 'react';
import {useDispatch} from 'react-redux';
import {clearInspectedHex} from '../../../redux/actions';
import {REGISTRY_SINGLETON} from '../../../scenes/Registry';
import {MASKED_ICON_TONES, MaskedIcon} from '../../coloredIcons/MaskedIcon/MaskedIcon';
import {GAME_BUTTON_SIZES, GAME_BUTTON_VARIANTS, GameButton} from '../../gameUi/GameButton';

/**
 * Крестик в заголовке футера. По умолчанию снимает инспекцию ячейки; на этапе
 * ближнего боя ему передают deselectUnit — там заголовок относится к
 * выбранному отряду, а не к ячейке.
 *
 * @param {Function} action - создатель экшена, который снимает выделение
 * @param {string} title - подсказка при наведении
 */
const DeselectButton = ({action = clearInspectedHex, title = 'Снять выделение с ячейки'}) => {
  const dispatch = useDispatch();

  const handleClick = () => {
    REGISTRY_SINGLETON.getSoundManager().playSideMenuClick();
    dispatch(action());
  };

  return (
    <GameButton
      variant={GAME_BUTTON_VARIANTS.SUNK}
      size={GAME_BUTTON_SIZES.ICON}
      onClick={handleClick}
      className={'footer-heading-btn'}
      title={title}
    >
      <MaskedIcon
        src={'/img/icons/exit.png'}
        alt={'Снять выделение'}
        tone={MASKED_ICON_TONES.CONTROLS}
      />
    </GameButton>
  );
};

export default DeselectButton;
